import * as vendorEvaluationService from "@/services/vendorEvaluationService";

export default {
  name: "EvaluationApprovalView",

  data() {
    return {
      loading: false,
      loadError: false,
      items: [],

      search: "",
      statusFilter: "ALL", // ALL | PENDING_APPROVAL | APPROVED | REJECTED
      statusOptions: [
        { value: "ALL", label: "Semua Status" },
        { value: "PENDING_APPROVAL", label: "Menunggu Approval" },
        { value: "APPROVED", label: "Disetujui" },
        { value: "REJECTED", label: "Ditolak" },
      ],

      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
    };
  },

  computed: {
    filteredItems() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.items;
      return this.items.filter((item) =>
        [item.nama_supplier, item.penilai_name, item.status_label]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q)),
      );
    },

    total() {
      return this.filteredItems.length;
    },

    totalPages() {
      return Math.ceil(this.total / this.perPage) || 1;
    },

    pagedItems() {
      const start = (this.page - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },

    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  created() {
    this.fetchList();
  },

  methods: {
    async fetchList() {
      this.loading = true;
      this.loadError = false;
      try {
        const res = await vendorEvaluationService.getEvaluationList(
          this.statusFilter,
        );
        this.items = res?.data || [];
        this.page = 1;
      } catch (err) {
        console.error("Gagal mengambil daftar evaluasi:", err);
        this.loadError = true;
        this.items = [];
      } finally {
        this.loading = false;
      }
    },

    onStatusChange() {
      this.fetchList();
    },

    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    scoreBadgeClass(score) {
      const n = Number(score);
      if (Number.isNaN(n)) return "status-secondary";
      return n < 2 ? "badge-danger" : "badge-success";
    },

    statusBadgeClass(status) {
      switch (status) {
        case "PENDING_APPROVAL":
          return "badge-warning";
        case "APPROVED":
          return "badge-success";
        case "REJECTED":
          return "badge-danger";
        case "DRAFT":
          return "status-secondary";
        default:
          return "status-secondary";
      }
    },

    goToDetail(item) {
      this.$router.push({
        name: "VendorEvaluationForm",
        params: { id: item.evaluation_id },
        query: { mode: "view", from: "approval" },
      });
    },

    /** Buat ulang evaluasi yang ditolak – buka form create dengan prefill dari dokumen/vendor */
    goToRedo(item) {
      const query = {
        mode: "create",
        from_rejected_id: item.evaluation_id,
      };
      if (item.document_id) query.documentId = item.document_id;
      if (item.mst_corporate_id) query.vendorId = item.mst_corporate_id;
      if (item.nama_supplier) query.namaSupplier = item.nama_supplier;

      this.$router.push({
        name: "VendorEvaluationForm",
        query,
      });
    },

    changePage(p) {
      if (p === "..." || p < 1 || p > this.totalPages) return;
      this.page = p;
    },
  },
};
